var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { adoptedStyle, customElement } from '@mantou/gem/lib/decorators';
import { GemElement, html } from '@mantou/gem/lib/element';
import { createCSSSheet, css } from '@mantou/gem/lib/utils';
import { theme } from '../lib/theme';
import { sleep } from '../lib/utils';
const style = createCSSSheet(css `
  :host {
    view-transition-name: dy-page-loadbar;
    z-index: ${theme.popupZIndex};
    position: fixed;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    top: env(titlebar-area-height, var(--titlebar-area-height, 0px));
    left: 0;
    height: 2px;
    transition: width 0.3s;
    background-color: ${theme.informativeColor};
  }
  .head {
    width: 300px;
    height: 400%;
    background-color: inherit;
    border-start-start-radius: 50%;
    border-end-start-radius: 50%;
    filter: drop-shadow(0 0 4px ${theme.informativeColor});
  }
`);
/**
 * @customElement dy-page-loadbar
 */
let DuoyunPageLoadbarElement = class DuoyunPageLoadbarElement extends GemElement {
    constructor() {
        super();
        this.state = {
            progress: 0,
        };
        this.mounted = () => {
            Loadbar.instance = this;
            return () => (Loadbar.instance = undefined);
        };
        this.render = () => {
            return html `
      <style>
        :host {
          width: ${this.state.progress}%;
        }
      </style>
      <div class="head"></div>
    `;
        };
        document.body.append(this);
        this.internals.role = 'progressbar';
    }
    static async start({ delay = 100 } = {}) {
        clearInterval(Loadbar.timer);
        Loadbar.timer = window.setTimeout(() => {
            const instance = Loadbar.instance || new Loadbar();
            instance.setState({ progress: 0 });
            Loadbar.timer = window.setInterval(() => {
                instance.setState({ progress: instance.state.progress + (95 - instance.state.progress) * 0.1 });
            }, 100);
        }, delay);
    }
    static async end() {
        clearInterval(Loadbar.timer);
        const instance = Loadbar.instance;
        if (instance) {
            instance.setState({ progress: 100 });
            await sleep(300);
            instance.remove();
        }
    }
};
DuoyunPageLoadbarElement.timer = 0;
DuoyunPageLoadbarElement = __decorate([
    customElement('dy-page-loadbar'),
    adoptedStyle(style)
], DuoyunPageLoadbarElement);
export { DuoyunPageLoadbarElement };
export const Loadbar = DuoyunPageLoadbarElement;
//# sourceMappingURL=page-loadbar.js.map